export var dmsMenuItems = [
    {
        id: "dms",
        label: "Document Management",
        icon: "ri-file-copy-2-fill",
        link: "/#",
        subItems: [
            { id: "dms-dashboard", label: "Dashboard", icon: "ri-bar-chart-2-fill", link: "/dms/dashboard", parentId: "dms", permissionTypeId: [] },
            { id: "dms-documents", label: "Documents", icon: "ri-file-list-3-line", link: "/dms/documents", parentId: "dms", permissionTypeId: [] },
            { id: "dms-mydocuments", label: "My Documents", icon: "ri-folder-user-fill", link: "/dms/mydocuments", parentId: "dms", permissionTypeId: [] },
            { id: "dms-incoming", label: "Incoming", icon: "ri-inbox-fill", link: "/dms/incoming", parentId: "dms", badgeColor: "danger", badgeName: "3", permissionTypeId: [] },
            { id: "dms-outgoing", label: "Outgoing", icon: "ri-send-plane-2-fill", link: "/dms/outgoing", parentId: "dms", badgeColor: "success", badgeName: "6", permissionTypeId: [] },
            { id: "dms-archive", label: "Archive", icon: "ri-archive-fill", link: "/dms/archive", parentId: "dms", permissionTypeId: [] },
            { id: "dms-reports", label: "Reports", icon: "ri-article-line", link: "/dms/reports", parentId: "dms", permissionTypeId: [] },
            { id: "dms-settings", label: "Settings", icon: "ri-settings-2-fill", link: "/dms/settings", parentId: "dms", permissionTypeId: [] },
        ],
    },
];